<template>
  <div class="tableList-container">
    <div class="thead gray-cl main-bg" v-if="theadList && theadList.length">
      <span v-for="(item, index) in theadList" :key="'thead' + index" :style="{ width: cellWidth[index] + 'px' }">
        {{ item }}
      </span>
    </div>
    <div class="tbody main-bg" :style="tbodyStyle">
      <vue-scroll :ops="ops" ref="vs" @handle-resize="handleResize">
        <div class="tbodyBar" :style="tbodyStyle">
          <template v-if="differNUmber > 0 && type === 'asks'">
            <div class="symbol-item main-second-bg-h gray-cl" v-for="(item, index) in differNUmber" :key="index + 'diff'">
              <span class="td-symbol" :class="priceClass" :style="{ width: cellWidth[0] + 'px' }">
                --
              </span>
              <span class="td-price" :style="{ width: cellWidth[1] + 'px' }">
                --
              </span>
              <span class="td-rose" :style="{ width: cellWidth[2] + 'px' }">
                --
              </span>
            </div>
          </template>
          <template v-for="(item, index) in dataList">
            <div v-if="isShow(index)" :class="{ 'change-item': item.diff }" class="symbol-item main-second-bg-h gray-cl" :key="index + 'item'">
              <!-- 价格 -->
              <div class="bg a-21-bg"></div>
              <span class="td-symbol" @click="handelPrice(item.price)" :class="priceClass" :style="{ width: cellWidth[0] + 'px' }">
                {{thousandsComma( item.price )}}
              </span>
              <!-- 数量 -->
              <span class="td-price" :style="{ width: cellWidth[1] + 'px' }">
                {{ thousandsComma(item.vol) }}
                <div v-if="flashSwitchs" class="change" :class="trBgClass(item.diff)"></div>
              </span>
              <!-- 累计 -->
              <span class="td-rose" :style="{ width: cellWidth[2] + 'px' }">
                {{ thousandsComma(item.total) }}
                <b class="tr-bg" :class="trBgClass_two" :style="setWidth(item.total)"></b>
              </span>
            </div>
          </template>
          <template v-if="differNUmber > 0 && type === 'buy'">
            <div class="symbol-item main-second-bg-h gray-cl" v-for="(item, index) in differNUmber" :key="index + 'diff'">
              <span class="td-symbol" :class="priceClass" :style="{ width: cellWidth[0] + 'px' }">
                --
              </span>
              <span class="td-price" :style="{ width: cellWidth[1] + 'px' }">
                --
              </span>
              <span class="td-rose" :style="{ width: cellWidth[2] + 'px' }">
                --
              </span>
            </div>
          </template>
        </div>
      </vue-scroll>
    </div>
  </div>
</template>

<script>
import { thousandsComma } from '@/utils';
import { fixUpDownColor } from '@/utils/storage';

export default {
  // mixins: [mixin],
  mounted() {
    this.init();
  },
  components: {
  },
  data() {
    return {
      ops: {
        scrollPanel: {
          scrollingY: true,
          initialScrollY: 0,
        },
      },
    };
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    theadList: {
      type: Array,
      default: () => [],
    },
    dataList: {
      type: Array,
      default: () => [],
    },
    cellWidth: {
      type: Array,
      default: () => [],
    },
    bodyHeight: {
      type: Number,
      default: 0,
    },
    lineNumber: {
      type: Number,
      default: 10,
    },
    maxValue: {
      type: Number,
    },
  },
  computed: {
    tbodyStyle() {
      return {
        height: `${this.bodyHeight}px`,
      };
    },
    priceClass() {
      return this.type === 'buy' ? fixUpDownColor('u-1-cl') : fixUpDownColor('u-4-cl');
    },
    trBgClass_two() {
      return this.type === 'buy' ? 'u-3-bg' : 'u-6-bg';
    },
    differNUmber() {
      if (this.lineNumber - this.dataList.length > 0) {
        return this.lineNumber - this.dataList.length;
      }
      return 0;
    },
    flashSwitchs() {
      return this.$store.state.baseData.trade_depth_is_flash;
    },
  },
  watch: {
    theadList(val) {
      this.scrollTo(val);
    },
    bodyHeight(val, oldval) {
      if (oldval && val) {
        if (this.type === 'asks' && val > 500) {
          this.scrollTo();
        }
      }
    },
    dataList(val, oldval) {
      if (this.type === 'asks' && !oldval.length) {
        setTimeout(() => {
          this.scrollTo();
        });
      }
    },
  },
  methods: {
    init() {
      this.scrollTo();
    },
    isShow(i) {
      if (this.type === 'asks') {
        const num = this.dataList.length - this.lineNumber;
        return num <= i;
      }
      return i < this.lineNumber;
    },
    trBgClass(diff) {
      return diff === 1 ? 'u-2-bg' : 'u-5-bg';
    },
    handelPrice(price) {
      this.$bus.$emit('HANDEL_PRICE', price);
    },
    scrollTo() {
      if (this.$refs.vs) {
        this.$refs.vs.scrollTo({
          y: 99999,
        }, false);
      }
    },
    handleResize() {
      if (this.type === 'asks') {
        setTimeout(() => {
          this.scrollTo();
        }, 100);
      }
    },
    setWidth(vol) {
      // const length = this.type === 'buy' ? this.dataList.length - 1 : 0;
      // const maxValue = this.dataList[length].total;
      let W = 0;
      if (vol === '--' || this.maxValue === '--') {
        return 0;
      }
      W = (parseFloat(vol) / parseFloat(this.maxValue)) * 100 + 5;
      if (W > 105) {
        W = 105;
      }
      return { width: `${W}%` };
    },
    thousandsComma(num) {
      if (num) {
        return thousandsComma(num);
      }
      return num;
    },
  },
};
</script>

<style lang="scss" scoped>
.tableList-container {
  .thead {
    height: 29px;
    line-height: 29px;
    // border-bottom-width: 1px;
    // border-bottom-style: solid;
    margin-bottom: 1px;
    font-size: 12px;

    span {
      display: inline-block;

      &:first-child {
        text-align: left;
        box-sizing: border-box;
        padding-left: 15px;
      }
    }
  }

  .tbody {
    padding: 0;
    position: relative;
    font-size: 12px;
    transiton: height 0.5s ease;
    width: 100%;
    -webkit-transition: height 0.5s ease;

    &.no-padding {
      padding: 0;
    }
    .symbol-item {
      padding: 1px 15px 1px 0;
      line-height: 24px;
      cursor: pointer;
      position: relative;

      .bg {
        display: none;
      }

      &.change-item {
        .change {
          position: absolute;
          animation: 1s opacity2 0s 1;
          top: 0;
          left: 2px;
          height: 100%;
          width: 100%;
          opacity: 0;
        }
      }

      &:hover {
        .bg {
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
        }
      }

      span {
        &.td-symbol {
          text-align: left;
          box-sizing: border-box;
          padding-left: 16px;
        }
      }
    }
  }

  @keyframes opacity2 {
    0% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  @keyframes opacity2 {
    0% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  @keyframes opacity2 {
    0% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  .thead, .tbody {
    span {
      display: inline-block;
      text-align: right;
      position: relative;
      z-index: 9;

      .icon {
        display: inline-block;
        vertical-align: middle;
        height: 16px;
        background: #f00;
        float: left;
        margin: 8px 5px 0 0;
      }

      .hover_show {
        display: none;
      }

      &:hover {
        .hover_show {
          display: block;
        }

        .hover_hide {
          display: none;
        }
      }
    }
  }

  .tr-bg {
    position: absolute;
    height: 24px;
    top: 0;
    right: -20px;
    z-index: 1;
    padding: 0;
    width: 10%;
    transiton: width 0.5s ease;
    -webkit-transition: width 0.5s ease;
  }
}
</style>
